import api from './axiosConfig';

export interface OrganizationDto {
  id: string;
  organizationFullName: string;
  organizationShortName: string;
  isActive: boolean;
  tenantId: string;
}

interface BranchDto {
  id: string;
  organizationId?: string | null;
  branchName: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  phone?: string;
  isActive: boolean;
  tenantId?: string;
}

interface DepartmentDto {
  id: string;
  branchId?: string | null;
  departmentName: string;
  description?: string;
  isActive: boolean;
  tenantId: string;
}

interface DesignationDto {
  id: string;
  departmentId?: string | null;
  designationName: string;
  description?: string;
  isActive: boolean;
  tenantId: string;
}

interface AccountInformationDto {
  id: string;
  companyName: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  zipPostalCode?: string;
  country?: string;
  state?: string;
  gstin: string;
  isActive: boolean;
  tenantId: string;
}

export const administrationApi = {
  getOrganizations: async (tenantId: string): Promise<OrganizationDto[]> => {
    const response = await api.get<OrganizationDto[]>(`/Administration/origination/${tenantId}`);
    return response.data;
  },
  createOrganization: async (payload: {
    organizationFullName: string;
    organizationShortName: string;
    isActive: boolean;
    tenantId: string;
    createdBy: string;
  }): Promise<string> => {
    const response = await api.post<string>('/Administration/origination', payload);
    return response.data;
  },
  updateOrganization: async (payload: {
    id: string;
    organizationFullName: string;
    organizationShortName: string;
    isActive: boolean;
    modifiedBy: string;
  }): Promise<boolean> => {
    const response = await api.put<boolean>('/Administration/origination', payload);
    return response.data;
  },

  getBranches: async (tenantId: string, organizationId?: string): Promise<BranchDto[]> => {
    const response = await api.get<BranchDto[]>(`/Administration/branch/${tenantId}`, {
      params: organizationId ? { organizationId } : undefined,
    });
    return response.data;
  },
  createBranch: async (payload: {
    organizationId?: string;
    branchName: string;
    address: string;
    city: string;
    state: string;
    country: string;
    phone: string;
    isActive: boolean;
    tenantId: string;
    createdBy: string;
  }): Promise<string> => {
    const response = await api.post<string>('/Administration/branch', payload);
    return response.data;
  },
  updateBranch: async (payload: {
    id: string;
    organizationId?: string;
    branchName: string;
    address: string;
    city: string;
    state: string;
    country: string;
    phone: string;
    isActive: boolean;
    modifiedBy: string;
  }): Promise<boolean> => {
    const response = await api.put<boolean>('/Administration/branch', payload);
    return response.data;
  },

  getDepartments: async (tenantId: string, branchId?: string): Promise<DepartmentDto[]> => {
    const response = await api.get<DepartmentDto[]>(`/Administration/department/${tenantId}`, {
      params: branchId ? { branchId } : undefined,
    });
    return response.data;
  },
  createDepartment: async (payload: {
    branchId?: string;
    departmentName: string;
    description: string;
    isActive: boolean;
    tenantId: string;
    createdBy: string;
  }): Promise<string> => {
    const response = await api.post<string>('/Administration/department', payload);
    return response.data;
  },
  updateDepartment: async (payload: {
    id: string;
    branchId?: string;
    departmentName: string;
    description: string;
    isActive: boolean;
    modifiedBy: string;
  }): Promise<boolean> => {
    const response = await api.put<boolean>('/Administration/department', payload);
    return response.data;
  },

  getDesignations: async (tenantId: string, departmentId?: string): Promise<DesignationDto[]> => {
    const response = await api.get<DesignationDto[]>(`/Administration/designation/${tenantId}`, {
      params: departmentId ? { departmentId } : undefined,
    });
    return response.data;
  },
  createDesignation: async (payload: {
    departmentId?: string;
    designationName: string;
    description: string;
    isActive: boolean;
    tenantId: string;
    createdBy: string;
  }): Promise<string> => {
    const response = await api.post<string>('/Administration/designation', payload);
    return response.data;
  },
  updateDesignation: async (payload: {
    id: string;
    departmentId?: string;
    designationName: string;
    description: string;
    isActive: boolean;
    modifiedBy: string;
  }): Promise<boolean> => {
    const response = await api.put<boolean>('/Administration/designation', payload);
    return response.data;
  },

  getAccountInformation: async (tenantId: string): Promise<AccountInformationDto[]> => {
    const response = await api.get<AccountInformationDto[]>(`/Administration/account-information/${tenantId}`);
    return response.data;
  },
  createAccountInformation: async (payload: {
    companyName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    zipPostalCode: string;
    country: string;
    state: string;
    gstin: string;
    isActive: boolean;
    tenantId: string;
    createdBy: string;
  }): Promise<string> => {
    const response = await api.post<string>('/Administration/account-information', payload);
    return response.data;
  },
  updateAccountInformation: async (payload: {
    id: string;
    companyName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    zipPostalCode: string;
    country: string;
    state: string;
    gstin: string;
    isActive: boolean;
    modifiedBy: string;
  }): Promise<boolean> => {
    const response = await api.put<boolean>('/Administration/account-information', payload);
    return response.data;
  },
};
